import { getCoChannel } from './util';

export function initCoChannel() {
  document.body.classList.add(`co-${getCoChannel()}`);
}
